import { decryptData } from '@/components/reusable/crypto/Cipher';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { showToast } from '../toastMessage/ToastMessage';
import { vAlign } from '@progress/kendo-drawing';

const filterIdOrReferenceId = (data, hiddenKey) => {
  return data.map((filterData) => {
    return Object.fromEntries(
      Object.entries(filterData).filter(([key, _]) => key !== hiddenKey),
    );
  });
};

// export const generatePDF = (
//   filteredTableData,
//   columns,
//   task = '',
//   extension,
//   startDate,
//   endDate,
//   hideDate,
//   itemName,
//   // format = 'A4',
// ) => {
//   const userData = decryptData(localStorage.getItem('userData'));

//   if (!columns.length) {
//     showToast('No data to export', 'info');
//     return;
//   }

//   const doc = new jsPDF({
//     orientation: columns.length > 10 ? 'landscape' : 'portrait',
//     compress: true,
//     // format: format || 'A4',
//   });

//   filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

//   const companyDetails = {
//     title: `${userData?.companyName || 'Company Name'}`,
//     branchInfo: `${userData?.branchName || 'Company Branch Name'}, ${userData?.branchAddress || 'Branch Address'}`,
//     phone: `+977 ${userData?.companyNumber || 'Phone Number'}`,
//     email: `${userData?.companyEmail || 'Email Address'}`,
//     date: hideDate
//       ? `${extension}` // Show only extension if hideDate is true
//       : startDate && endDate
//         ? `${extension} from: ${startDate} to ${endDate}` // Show extension with valid date range
//         : `${extension}`,
//   };

//   const footerText = 'DeiArtha';

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const marginTop = 20; // Top margin for header
//   const lineHeight = 7; // Vertical spacing between lines

//   // Table Data
//   const tableHeaders = [columns.map((column) => column?.title ?? column)];
//   const tableRows = filteredTableData.map((item) =>
//     Object.values(
//       Object.fromEntries(
//         Object.entries(item).filter(([key]) => tableHeaders[0].includes(key)),
//       ),
//     ),
//   );

//   doc.autoTable({
//     head: tableHeaders,
//     body: tableRows,
//     // startY: marginTop + 5.5 * lineHeight,
//     margin: { left: 7, right: 7 },
//     styles: {
//       fontSize: 9,
//       fontStyle: 'normal',
//       cellPadding: 2,
//       lineWidth: 0.1,
//       lineColor: [200, 200, 200],
//     },
//     headStyles: {
//       // fillColor: [200, 200, 200],
//       // textColor: 0,
//       // fontStyle: 'bold',
//       fillColor: '#4bb98f',
//       textColor: [255, 255, 255],
//       fontStyle: 'bold',
//     },
//     alternateRowStyles: {
//       fillColor: [240, 240, 240],
//     },
//     didParseCell: (data) => {
//       if (data.row.index === tableRows.length - 1) {
//         // Apply bold font style to the last row
//         data.cell.styles.fontStyle = 'bold';
//         data.cell.styles.textColor = [0, 0, 0]; // Black color
//       }
//     },
//     didDrawPage: (data) => {
//       const pageHeight = doc.internal.pageSize.height;
//       const footerY = pageHeight - 8;

//       const headerY = 20; // Y-position for the header
//       const lineY = headerY + 5.5 * lineHeight; // Y-position for the separator line

//       // Redraw the title and headers on each page
//       doc.setFontSize(16); // Larger font for title
//       doc.setFont('helvetica', 'bold');
//       doc.text(companyDetails.title, pageWidth / 2, marginTop, {
//         align: 'center',
//       });

//       doc.setFontSize(12);
//       doc.setFont('helvetica', 'normal');
//       doc.text(
//         companyDetails.branchInfo,
//         pageWidth / 2,
//         marginTop + lineHeight,
//         {
//           align: 'center',
//         },
//       );
//       doc.text(
//         companyDetails.phone,
//         pageWidth / 2,
//         marginTop + 2 * lineHeight,
//         {
//           align: 'center',
//         },
//       );
//       doc.text(
//         companyDetails.email,
//         pageWidth / 2,
//         marginTop + 3 * lineHeight,
//         {
//           align: 'center',
//         },
//       );
//       doc.setFontSize(7);
//       doc.setFont('helvetica', 'italic'); // Italic for the report period
//       doc.text(companyDetails?.date, 15, marginTop + 4 * lineHeight + 5, {
//         align: 'left',
//       });

//       // Footer
//       doc.setFontSize(7);
//       doc.setTextColor(100);
//       doc.text(
//         `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
//         15,
//         footerY,
//       );
//       doc.text(footerText, pageWidth / 2, footerY, { align: 'center' });
//     },

//     margin: { top: marginTop + 5 * lineHeight },
//   });

//   if (task === 'print') {
//     doc.autoPrint({ variant: 'non-conform' });
//     doc.output('dataurlnewwindow');
//   } else {
//     doc.save(
//       extension ? `${extension?.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
//     );
//   }
// };

export const generatePDF = (
  filteredTableData,
  columns,
  task = '',
  extension,
  startDate,
  endDate,
  hideDate,
  itemName,
) => {
  const userData = decryptData(localStorage.getItem('userData'));

  if (!columns.length) {
    showToast('No data to export', 'info');
    return;
  }

  const doc = new jsPDF({
    orientation: columns.length > 10 ? 'landscape' : 'portrait',
    compress: true,
  });

  filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

  const companyDetails = {
    title:
      extension === 'Sales Report'
        ? `${userData?.branchName || 'Branch Name'}`
        : `${userData?.companyName || 'Company Name'}`,
    branchInfo:
      extension === 'Sales Report'
        ? `${userData?.branchAddress || 'Branch Address'}`
        : `${userData?.branchName || 'Company Branch Name'}, ${userData?.branchAddress || 'Branch Address'}`,
    phone: `+977 ${userData?.branchNumber || 'Phone Number'}`,
    email: `${userData?.branchEmail || 'Email Address'}`,
    date: hideDate
      ? `${extension}`
      : startDate && endDate
        ? `${extension} from: ${startDate} to ${endDate}`
        : `${extension}`,
  };

  const footerText = 'DipArtha';
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginTop = 20;
  const lineHeight = 7;

  const pageHeight = doc.internal.pageSize.height;
  const footerY = pageHeight - 8;

  // Header for the first page
  const addHeader = () => {
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(companyDetails.title, pageWidth / 2, marginTop, {
      align: 'center',
    });
    doc.setFontSize(11);
    const panText = `PAN No. ${userData?.brancPanNumber || userData?.branchPanNumber || ''}`;
    const panTextWidth = doc.getTextWidth(panText);
    const panX = pageWidth - panTextWidth - 5;
    doc.text(panText, panX, marginTop, {
      align: 'left',
    });

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(companyDetails.branchInfo, pageWidth / 2, marginTop + lineHeight, {
      align: 'center',
    });
    doc.text(
      companyDetails.phone + ' ' + companyDetails.email,
      pageWidth / 2,
      marginTop + 2 * lineHeight,
      {
        align: 'center',
      },
    );
    // doc.text(companyDetails.email, pageWidth / 2, marginTop + 3 * lineHeight, {
    //   align: 'center',
    // });
    // doc.setFontSize(7);
    doc.setFont('helvetica', 'italic');
    // doc.text(companyDetails?.date, 15, marginTop + 4 * lineHeight + 5, {
    //   align: 'left',
    // });

    doc.text(
      companyDetails?.date,
      pageWidth / 2,
      marginTop + 2.5 * lineHeight + 5,
      { align: 'center' },
    );
  };

  // Add header to the first page
  addHeader();

  // Table Data
  const tableHeaders = [columns.map((column) => column?.title ?? column)];
  const tableHeadersRow = [columns.map((column) => column?.key ?? column)];
  // const tableRows = filteredTableData.map((item) =>
  //   Object.values(
  //     Object.fromEntries(
  //       Object.entries(item).filter(([key]) =>
  //         tableHeadersRow[0].includes(key),
  //       ),
  //     ),
  //   ),
  // );

  const tableRows = filteredTableData.map((item) =>
    tableHeadersRow[0]?.map((key) => item[key]),
  );

  doc.autoTable({
    head: tableHeaders,
    body: tableRows,
    margin: { left: 7, right: 7 },
    startY: marginTop + 4 * lineHeight, // Set initial Y position for the first page
    styles: {
      fontSize: 9,
      fontStyle: 'normal',
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: [200, 200, 200],
    },
    headStyles: {
      fillColor: '#4bb98f',
      textColor: [255, 255, 255],
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
    didParseCell: (data) => {
      if (data.row.index === tableRows.length - 1) {
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.textColor = [0, 0, 0];
      }
    },
    didDrawPage: (data) => {
      // No header for subsequent pages, table starts at top
      if (data.pageNumber > 1) {
        data.settings.startY = 15; // Start table near the top of subsequent pages
      }

      // Footer
      doc.setFontSize(7);
      doc.setTextColor(100);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        15,
        footerY,
      );
      doc.text(footerText, pageWidth / 2, footerY, { align: 'center' });
    },
  });

  if (task === 'print') {
    doc.autoPrint({ variant: 'non-conform' });
    doc.output('dataurlnewwindow');
  } else {
    doc.save(
      extension ? `${extension?.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
    );
  }
};

export const generatePDFNew = (
  filteredTableData,
  columns,
  task = '',
  extension,
  startDate,
  endDate,
  hideDate,
  itemName,
) => {
  const userData = decryptData(localStorage.getItem('userData'));

  if (!columns.length) {
    showToast('No data to export', 'info');
    return;
  }

  const doc = new jsPDF({
    orientation: columns.length > 10 ? 'landscape' : 'portrait',
    compress: true,
  });

  filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

  const companyDetails = {
    title: `${userData?.companyName || 'Company Name'}`,
    branchInfo: `${userData?.branchName || 'Company Branch Name'}, ${userData?.branchAddress || 'Branch Address'}`,
    phone: `+977 ${userData?.companyNumber || 'Phone Number'}`,
    email: `${userData?.companyEmail || 'Email Address'}`,
    date: hideDate
      ? `${extension}`
      : startDate && endDate
        ? `${extension} from: ${startDate} to ${endDate}`
        : `${extension}`,
  };

  const footerText = 'DipArtha';
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginTop = 20;
  const lineHeight = 7;

  const pageHeight = doc.internal.pageSize.height;
  const footerY = pageHeight - 8;

  // Header for the first page
  const addHeader = () => {
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(companyDetails.title, pageWidth / 2, marginTop, {
      align: 'center',
    });

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(companyDetails.branchInfo, pageWidth / 2, marginTop + lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.phone, pageWidth / 2, marginTop + 2 * lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.email, pageWidth / 2, marginTop + 3 * lineHeight, {
      align: 'center',
    });
    doc.setFontSize(7);
    doc.setFont('helvetica', 'italic');
    doc.text(companyDetails?.date, 15, marginTop + 4 * lineHeight + 5, {
      align: 'left',
    });
  };

  // Add header to the first page
  addHeader();

  // Table Data
  const tableHeaders = [columns.map((column) => column?.title ?? column)];

  const tableHeadersRow = [columns.map((column) => column?.key ?? column)];

  const tableRows = filteredTableData.map((item) =>
    Object.values(
      Object.fromEntries(
        Object.entries(item).filter(([key]) =>
          tableHeadersRow[0].includes(key),
        ),
      ),
    ),
  );

  doc.autoTable({
    head: tableHeaders,
    body: tableRows,
    margin: { left: 7, right: 7 },
    startY: marginTop + 5 * lineHeight, // Set initial Y position for the first page
    styles: {
      fontSize: 9,
      fontStyle: 'normal',
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: [200, 200, 200],
    },
    headStyles: {
      fillColor: '#4bb98f',
      textColor: [255, 255, 255],
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },

    didDrawPage: (data) => {
      // No header for subsequent pages, table starts at top
      if (data.pageNumber > 1) {
        data.settings.startY = 15; // Start table near the top of subsequent pages
      }

      // Footer
      doc.setFontSize(7);
      doc.setTextColor(100);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        15,
        footerY,
      );
      doc.text(footerText, pageWidth / 2, footerY, { align: 'center' });
    },
  });

  if (task === 'print') {
    doc.autoPrint({ variant: 'non-conform' });
    doc.output('dataurlnewwindow');
  } else {
    doc.save(
      extension ? `${extension?.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
    );
  }
};

// export const generateLedgerReportPdf = (
//   filteredTableData,
//   columns,
//   task = '',
//   extension,
//   startDate,
//   endDate,
//   hideDate,
//   itemName,
//   tableData,
// ) => {
//   const userData = decryptData(localStorage.getItem('userData'));

//   if (!columns.length || !filteredTableData.length) {
//     showToast('No data to export', 'info');
//     return;
//   }

//   const doc = new jsPDF({
//     orientation: columns.length > 10 ? 'landscape' : 'portrait',
//     compress: true,
//   });

//   // Filter out unnecessary fields
//   filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

//   // Company details for the header
//   const companyDetails = {
//     title: `${userData?.companyName || 'Company Name'}`,
//     branchInfo: `${userData?.branchName || 'Company Branch Name'}, ${userData?.branchAddress || 'Branch Address'}`,
//     phone: `+977 ${userData?.companyNumber || 'Phone Number'}`,
//     email: `${userData?.companyEmail || 'Email Address'}`,
//     date: hideDate
//       ? `${extension}`
//       : startDate && endDate
//         ? `${extension} from: ${startDate} to ${endDate}`
//         : `${extension}`,
//   };

//   const footerText = 'DeepArtha';
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const marginTop = 20;
//   const lineHeight = 7;

//   // Define the 2D column headers
//   const tableHeaders = [
//     [
//       {
//         content: 'S.N.',
//         rowSpan: 2,
//         styles: { halign: 'center', valign: 'middle' },
//       },
//       {
//         content: 'Ledger Name',
//         rowSpan: 2,
//         styles: { halign: 'center', valign: 'middle' },
//       },
//       { content: 'Amount', colSpan: 2, styles: { halign: 'center' } },
//       { content: 'Metal', colSpan: 2, styles: { halign: 'center' } },
//     ],
//     [
//       { content: 'Dr Amount', styles: { halign: 'center' } },
//       { content: 'Cr Amount', styles: { halign: 'center' } },
//       { content: 'Dr Metal', styles: { halign: 'center' } },
//       { content: 'Cr Metal', styles: { halign: 'center' } },
//     ],
//   ];

//   const tableRows = filteredTableData.map((item, index) => [
//     index + 1,
//     item?.['Ledger Name'] || '',
//     item?.['Dr Amount'] || '',
//     item?.['Cr Amount'] || '',
//     item?.['Dr Metal'] || '',
//     item?.['Cr Metal'] || '',
//   ]);

//   const summaryRow = [
//     '',
//     {
//       content: 'Total: ',
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },
//     {
//       content: tableData?.totalData?.totalAmountDr || 0,
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },
//     {
//       content: tableData?.totalData?.totalAmountCr || 0,
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },

//     {
//       content: tableData?.totalData?.totalMetalDr || 0,
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },

//     {
//       content: tableData?.totalData?.totalMetalCr || 0,
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },
//   ];

//   const summaryRow1 = [
//     '',
//     {
//       content: `Opening Difference: Amount: ${tableData?.differenceData?.differenceAmount}, Metal: ${tableData?.differenceData?.differenceMetal}`,
//       colSpan: 8,
//       styles: { halign: 'left', fontStyle: 'bold' },
//     },
//   ];

//   // Generate the table using autoTable
//   doc.autoTable({
//     head: tableHeaders,
//     body: [...tableRows, summaryRow, summaryRow1],
//     margin: { left: 15, right: 15 },
//     styles: {
//       fontSize: 9,
//       fontStyle: 'normal',
//       cellPadding: 2,
//       lineWidth: 0.1,
//       lineColor: [200, 200, 200],
//     },
//     headStyles: {
//       fillColor: '4bb98f', // Green color for header as in the image
//       textColor: 255, // White text
//       fontStyle: 'bold',
//       halign: 'center',
//     },
//     alternateRowStyles: {
//       fillColor: [240, 240, 240],
//     },
//     didParseCell: (data) => {
//       // if (data.row.index === tableRows.length - 1) {
//       //   data.cell.styles.fontStyle = 'bold';
//       //   data.cell.styles.textColor = [0, 0, 0];
//       // }
//     },
//     didDrawPage: (data) => {
//       const pageHeight = doc.internal.pageSize.height;
//       const footerY = pageHeight - 8;

//       // Header
//       doc.setFontSize(16);
//       doc.setFont('helvetica', 'bold');
//       doc.text(companyDetails.title, pageWidth / 2, marginTop, {
//         align: 'center',
//       });

//       doc.setFontSize(12);
//       doc.setFont('helvetica', 'normal');
//       doc.text(
//         companyDetails.branchInfo,
//         pageWidth / 2,
//         marginTop + lineHeight,
//         { align: 'center' },
//       );
//       doc.text(
//         companyDetails.phone,
//         pageWidth / 2,
//         marginTop + 2 * lineHeight,
//         { align: 'center' },
//       );
//       doc.text(
//         companyDetails.email,
//         pageWidth / 2,
//         marginTop + 3 * lineHeight,
//         { align: 'center' },
//       );
//       doc.setFontSize(7);
//       doc.setFont('helvetica', 'italic');
//       doc.text(companyDetails?.date, 15, marginTop + 4 * lineHeight + 5, {
//         align: 'left',
//       });

//       // Footer
//       doc.setFontSize(7);
//       doc.setTextColor(100);
//       doc.text(
//         `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
//         15,
//         footerY,
//       );
//       doc.text(footerText, pageWidth / 2, footerY, { align: 'center' });
//     },
//     margin: { top: marginTop + 5 * lineHeight },
//   });

//   // Output based on task
//   if (task === 'print') {
//     doc.autoPrint({ variant: 'non-conform' });
//     doc.output('dataurlnewwindow');
//   } else {
//     doc.save(
//       extension ? `${extension?.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
//     );
//   }
// };

//previous code for ledger-details-report

// export const generateLedgerDetailsPdf = (
//   filteredTableData,
//   columns,
//   extension,
//   startDate,
//   endDate,
//   itemName,
//   task = '',
//   hideDate,
// ) => {
//   const userData = decryptData(localStorage.getItem('userData'));

//   if (!columns.length) {
//     showToast('No data to export', 'info');
//     return;
//   }

//   const doc = new jsPDF({
//     orientation: columns.length > 10 ? 'landscape' : 'portrait',
//     compress: true,
//   });

//   filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

//   const companyDetails = {
//     title: `${userData?.companyName || 'Company Name'}`,
//     branchInfo: `${userData?.branchName || 'Company Branch'}, ${userData?.branchAddress || 'Branch Address'}`,
//     phone: `+977 ${userData?.companyNumber || 'Phone Number'}`,
//     email: `${userData?.companyEmail || 'Email Address'}`,
//     itemName: itemName || 'No Item Name',

//     date: hideDate
//       ? `${extension}`
//       : startDate && endDate
//         ? `${extension} from: ${startDate} to ${endDate}`
//         : `${extension}`,
//   };

//   const footerText = 'DeepArtha';

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();
//   const marginTop = 20;
//   const lineHeight = 7;

//   // Header
//   doc.setFontSize(16).setFont('helvetica', 'bold');
//   doc.text(companyDetails.title, pageWidth / 2, marginTop, { align: 'center' });

//   doc.setFontSize(12).setFont('helvetica', 'normal');
//   doc.text(companyDetails.branchInfo, pageWidth / 2, marginTop + lineHeight, {
//     align: 'center',
//   });
//   doc.text(companyDetails.phone, pageWidth / 2, marginTop + 2 * lineHeight, {
//     align: 'center',
//   });
//   doc.text(companyDetails.email, pageWidth / 2, marginTop + 3 * lineHeight, {
//     align: 'center',
//   });

//   const itemDetailsY = marginTop + 5 * lineHeight;
//   doc.setFontSize(10).setFont('helvetica', 'bold');
//   doc.text(companyDetails.date, 15, itemDetailsY);

//   let yPosition = itemDetailsY + lineHeight;

//   if (itemName) {
//     const ledgerText = `Ledger Name: ${itemName}`;
//     doc.setFontSize(10).setFont('helvetica', 'bold');
//     doc.text(ledgerText, 15, yPosition);
//     yPosition += lineHeight;
//   }

//   // Table preparation
//   const tableHeaders = [columns.map((col) => col?.title ?? col)];
//   const tableRows = filteredTableData.map((item) =>
//     Object.values(
//       Object.fromEntries(
//         Object.entries(item).filter(([key]) => tableHeaders[0].includes(key)),
//       ),
//     ),
//   );

//   doc.autoTable({
//     head: tableHeaders,
//     body: tableRows,
//     margin: { left: 15, right: 15, top: yPosition },
//     styles: {
//       fontSize: 8,
//       cellPadding: 2,
//     },
//     headStyles: {
//       fillColor: [200, 200, 200],
//       textColor: 0,
//       fontStyle: 'bold',
//     },
//     alternateRowStyles: {
//       fillColor: [240, 240, 240],
//     },
//     didParseCell: (data) => {
//       if (data.row.index === tableRows.length - 1) {
//         data.cell.styles.fontStyle = 'bold';
//         data.cell.styles.textColor = [0, 0, 0];
//       }
//     },
//     didDrawPage: (data) => {
//       doc.setFontSize(7);
//       doc.setTextColor(100);
//       doc.text(
//         `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
//         15,
//         pageHeight - 8,
//       );
//       doc.text(footerText, pageWidth / 2, pageHeight - 8, { align: 'center' });
//     },
//   });

//   // Export
//   if (task === 'print') {
//     doc.autoPrint({ variant: 'non-conform' });
//     doc.output('dataurlnewwindow');
//   } else {
//     doc.save(
//       extension ? `${extension.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
//     );
//   }
// };

export const generateLedgerReportPdf = (
  filteredTableData,
  columns,
  task = '',
  extension,
  startDate,
  endDate,
  hideDate,
  itemName,
  tableData,
  totalData,
  differenceData,
  checkList,
) => {
  const userData = decryptData(localStorage.getItem('userData'));

  if (!columns.length || !filteredTableData.length) {
    showToast('No data to export', 'info');
    return;
  }

  const doc = new jsPDF({
    orientation: columns.length > 10 ? 'landscape' : 'portrait',
    compress: true,
  });

  filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

  // Company details for the header
  const companyDetails = {
    title: `${userData?.companyName || 'Company Name'}`,
    branchInfo: `${userData?.branchName || 'Company Branch Name'}, ${userData?.branchAddress || 'Branch Address'}`,
    phone: `+977 ${userData?.branchNumber || 'Phone Number'}`,
    email: `${userData?.branchEmail || 'Email Address'}`,
    date: hideDate
      ? `${extension}`
      : startDate && endDate
        ? `${extension} from: ${startDate} to ${endDate}`
        : `${extension}`,
  };

  const footerText = 'DipArtha';
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginTop = 20;
  const lineHeight = 7;

  const pageHeight = doc.internal.pageSize.height;
  const footerY = pageHeight - 8;

  // Header for the first page
  const addHeader = () => {
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(companyDetails.title, pageWidth / 2, marginTop, {
      align: 'center',
    });

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(companyDetails.branchInfo, pageWidth / 2, marginTop + lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.phone, pageWidth / 2, marginTop + 2 * lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.email, pageWidth / 2, marginTop + 3 * lineHeight, {
      align: 'center',
    });
    doc.setFontSize(7);
    doc.setFont('helvetica', 'italic');
    doc.text(companyDetails?.date, 15, marginTop + 4 * lineHeight + 5, {
      align: 'left',
    });
  };

  // Add header to the first page
  addHeader();

  // Define the 2D column headers
  // const tableHeaders = [
  //   [
  //     {
  //       content: 'S.N.',
  //       rowSpan: 2,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Ledger Name',
  //       rowSpan: 2,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     { content: 'Amount', colSpan: 2, styles: { halign: 'center' } },
  //     { content: 'Metal', colSpan: 2, styles: { halign: 'center' } },
  //   ],
  //   [
  //     { content: 'Dr Amount', styles: { halign: 'center' } },
  //     { content: 'Cr Amount', styles: { halign: 'center' } },
  //     { content: 'Dr Metal', styles: { halign: 'center' } },
  //     { content: 'Cr Metal', styles: { halign: 'center' } },
  //   ],
  // ];

  // const tableRows = filteredTableData.map((item, index) => [
  //   index + 1,
  //   item?.['Ledger Name'] || '',
  //   item?.['Dr Amount'] || '',
  //   item?.['Cr Amount'] || '',
  //   item?.['Dr Metal'] || '',
  //   item?.['Cr Metal'] || '',
  // ]);

  // const summaryRow = [
  //   '',
  //   {
  //     content: 'Total: ',
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: tableData?.totalData?.totalAmountDr || 0,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: tableData?.totalData?.totalAmountCr || 0,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: tableData?.totalData?.totalMetalDr || 0,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: tableData?.totalData?.totalMetalCr || 0,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  // ];

  // const summaryRow1 = [
  //   '',
  //   {
  //     content: `Opening Difference: Amount: ${tableData?.differenceData?.differenceAmount}, Metal: ${tableData?.differenceData?.differenceMetal}`,
  //     colSpan: 8,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  // ];

  const totalsMap = {
    dr_amount: 'totalAmountDr',
    cr_amount: 'totalAmountCr',
    dr_metal: 'totalMetalDr',
    cr_metal: 'totalMetalCr',
  };

  const tableHeaders = [
    [
      ...(checkList.includes('S.N.')
        ? [
            {
              content: 'S.N.',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('ledger_name')
        ? [
            {
              content: 'Ledger Name',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('dr_amount') || checkList.includes('cr_amount')
        ? [
            {
              content: 'Amount',
              colSpan:
                (checkList.includes('dr_amount') ? 1 : 0) +
                (checkList.includes('cr_amount') ? 1 : 0),
              styles: { halign: 'center' },
            },
          ]
        : []),
      ...(checkList.includes('dr_metal') || checkList.includes('cr_metal')
        ? [
            {
              content: 'Metal',
              colSpan:
                (checkList.includes('dr_metal') ? 1 : 0) +
                (checkList.includes('cr_metal') ? 1 : 0),
              styles: { halign: 'center' },
            },
          ]
        : []),
      ...(checkList.includes('customer_address') ||
      checkList.includes('customer_mobile_number') ||
      checkList.includes('customer_pan_vat')
        ? [
            {
              content: 'Customer',
              colSpan:
                (checkList.includes('customer_address') ? 1 : 0) +
                (checkList.includes('customer_mobile_number') ? 1 : 0) +
                (checkList.includes('customer_pan_vat') ? 1 : 0),
              styles: { halign: 'center' },
            },
          ]
        : []),
    ],
    [
      ...(checkList.includes('dr_amount')
        ? [{ content: 'Dr Amount', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('cr_amount')
        ? [{ content: 'Cr Amount', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('dr_metal')
        ? [{ content: 'Dr Metal', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('cr_metal')
        ? [{ content: 'Cr Metal', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('customer_address')
        ? [{ content: 'Address', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('customer_mobile_number')
        ? [{ content: 'Mobile Number', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('customer_pan_vat')
        ? [{ content: 'Pan/VAT', styles: { halign: 'center' } }]
        : []),
    ],
  ];

  // Dynamic table rows
  const tableRows = filteredTableData.map((item, index) => [
    ...(checkList.includes('S.N.') ? [index + 1] : []),
    ...(checkList.includes('ledger_name') ? [item?.['ledger_name'] || ''] : []),
    ...(checkList.includes('dr_amount') ? [item?.['dr_ammount'] || ''] : []),
    ...(checkList.includes('cr_amount') ? [item?.['cr_amount'] || ''] : []),
    ...(checkList.includes('dr_metal') ? [item?.['dr_metal'] || ''] : []),
    ...(checkList.includes('cr_metal') ? [item?.['cr_metal'] || ''] : []),
    ...(checkList.includes('customer_address')
      ? [item?.['customer_address'] || '']
      : []),
    ...(checkList.includes('customer_mobile_number')
      ? [item?.['customer_mobile_number'] || '']
      : []),
    ...(checkList.includes('customer_pan_vat')
      ? [item?.['customer_pan_vat'] || '']
      : []),
  ]);

  // Totals row (dynamic based on visible cols)
  const summaryRow = [
    ...(checkList.includes('S.N.') ? [''] : []),
    ...(checkList.includes('ledger_name')
      ? [
          {
            content: 'Total:',
            styles: { halign: 'left', fontStyle: 'bold' },
          },
        ]
      : []),
    ...Object.keys(totalsMap)
      .filter((col) => checkList.includes(col))
      .map((col) => ({
        content: totalData?.[totalsMap[col]] || 0,
        styles: { halign: 'right', fontStyle: 'bold' },
      })),
  ];

  // Opening Difference row (dynamic colSpan)
  const summaryRow1 = [
    ...(checkList.includes('S.N.') ? [''] : []),
    {
      content: `Opening Difference: Amount: ${
        differenceData?.differenceAmount
      }, Metal: ${differenceData?.differenceMetal}`,
      colSpan: checkList.length - (checkList.includes('S.N.') ? 1 : 0),
      styles: { halign: 'left', fontStyle: 'bold' },
    },
  ];

  // Generate the table using autoTable
  doc.autoTable({
    head: tableHeaders,
    body: [...tableRows, summaryRow, summaryRow1],
    margin: { left: 15, right: 15 },
    startY: marginTop + 5 * lineHeight, // Set initial Y position for the first page
    styles: {
      fontSize: 9,
      fontStyle: 'normal',
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: [200, 200, 200],
    },
    headStyles: {
      fillColor: '4bb98f', // Green color for header
      textColor: 255, // White text
      fontStyle: 'bold',
      halign: 'center',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
    didParseCell: (data) => {
      // Customize cell parsing if needed
    },
    didDrawPage: (data) => {
      // No header for subsequent pages, table starts at top
      if (data.pageNumber > 1) {
        data.settings.startY = 15; // Start table near the top of subsequent pages
      }

      // Footer
      doc.setFontSize(7);
      doc.setTextColor(100);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        15,
        footerY,
      );
      doc.text(footerText, pageWidth / 2, footerY, { align: 'center' });
    },
  });

  // Output based on task
  if (task === 'print') {
    doc.autoPrint({ variant: 'non-conform' });
    doc.output('dataurlnewwindow');
  } else {
    doc.save(
      extension ? `${extension?.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
    );
  }
};

export const generateLedgerDetailsPdf = (
  filteredTableData,
  columns,
  extension,
  startDate,
  endDate,
  itemName,
  task = '',
  hideDate,
  totalData,
  summaryRows,
  checkList,
) => {
  const userData = decryptData(localStorage.getItem('userData'));

  if (!columns.length) {
    showToast('No data to export', 'info');
    return;
  }

  const doc = new jsPDF({
    orientation: columns.length > 10 ? 'landscape' : 'portrait',
    compress: true,
  });

  filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

  const companyDetails = {
    title: `${userData?.companyName || 'Company Name'}`,
    branchInfo: `${userData?.branchName || 'Company Branch'}, ${userData?.branchAddress || 'Branch Address'}`,
    phone: `+977 ${userData?.branchNumber || 'Phone Number'}`,
    email: `${userData?.branchEmail || 'Email Address'}`,
    itemName: itemName || 'No Item Name',
    date: hideDate
      ? `${extension}`
      : startDate && endDate
        ? `${extension} from: ${startDate} to ${endDate}`
        : `${extension}`,
  };

  const footerText = 'DipArtha';
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginTop = 20;
  const lineHeight = 7;

  // Function to draw header on each page
  const drawHeader = () => {
    doc.setFontSize(16).setFont('helvetica', 'bold');
    doc.text(companyDetails.title, pageWidth / 2, marginTop, {
      align: 'center',
    });

    doc.setFontSize(12).setFont('helvetica', 'normal');
    doc.text(companyDetails.branchInfo, pageWidth / 2, marginTop + lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.phone, pageWidth / 2, marginTop + 2 * lineHeight, {
      align: 'center',
    });
    doc.text(companyDetails.email, pageWidth / 2, marginTop + 3 * lineHeight, {
      align: 'center',
    });

    const itemDetailsY = marginTop + 5 * lineHeight;
    doc.setFontSize(10).setFont('helvetica', 'bold');
    doc.text(companyDetails.date, 15, itemDetailsY);

    if (itemName) {
      const ledgerText = `Ledger Name: ${itemName}`;
      doc.setFontSize(10).setFont('helvetica', 'bold');
      doc.text(ledgerText, 15, itemDetailsY + lineHeight);
    }

    return itemDetailsY + (itemName ? 2 * lineHeight : lineHeight); // Return the y-position after header
  };

  // Draw header on the first page
  let yPosition = drawHeader();

  // Define table headers
  // const tableHeaders = [
  //   [
  //     {
  //       content: 'Date',
  //       colSpan: 1,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Vch. Type',
  //       colSpan: 1,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Particular',
  //       colSpan: 1,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Remarks',
  //       colSpan: 1,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Vch. No.',
  //       colSpan: 1,
  //       styles: { halign: 'center', valign: 'middle' },
  //     },
  //     {
  //       content: 'Amount',
  //       colSpan: 3,
  //       styles: { halign: 'center' },
  //     },
  //     {
  //       content: 'Metal',
  //       colSpan: 3,
  //       styles: { halign: 'center' },
  //     },
  //   ],
  //   [
  //     '',
  //     '',
  //     '', // Particular
  //     '', // Remarks
  //     '', // Vch. No.
  //     'Dr Amount',
  //     'Cr Amount',
  //     'Balance',
  //     'Dr Metal',
  //     'Cr Metal',
  //     'Balance',
  //   ],
  // ];

  const tableHeaders = [
    [
      ...(checkList.includes('transaction_date')
        ? [
            {
              content: 'Date',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('Vch. Type')
        ? [
            {
              content: 'Vch. Type',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('particular')
        ? [
            {
              content: 'Particular',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('remarks')
        ? [
            {
              content: 'Remarks',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('vch_no')
        ? [
            {
              content: 'Vch. No.',
              rowSpan: 2,
              styles: { halign: 'center', valign: 'middle' },
            },
          ]
        : []),
      ...(checkList.includes('dr_amount') ||
      checkList.includes('cr_amount') ||
      checkList.includes('Balance Amount') ||
      checkList.includes('running_balance')
        ? [
            {
              content: 'Amount',
              colSpan:
                (checkList.includes('dr_amount') ? 1 : 0) +
                (checkList.includes('cr_amount') ? 1 : 0) +
                (checkList.includes('Balance Amount') ? 1 : 0) +
                (checkList.includes('running_balance') ? 1 : 0),
              styles: { halign: 'center' },
            },
          ]
        : []),
      ...(checkList.includes('dr_metal') ||
      checkList.includes('cr_metal') ||
      checkList.includes('Balance Metal') ||
      checkList.includes('running_metal_balance')
        ? [
            {
              content: 'Metal',
              colSpan:
                (checkList.includes('dr_metal') ? 1 : 0) +
                (checkList.includes('cr_metal') ? 1 : 0) +
                (checkList.includes('Balance Metal') ? 1 : 0) +
                (checkList.includes('running_metal_balance') ? 1 : 0),
              styles: { halign: 'center' },
            },
          ]
        : []),
    ],
    [
      ...(checkList.includes('dr_amount')
        ? [{ content: 'Dr Amount', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('cr_amount')
        ? [{ content: 'Cr Amount', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('Balance Amount')
        ? [{ content: 'Balance', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('running_balance')
        ? [{ content: 'Balance', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('dr_metal')
        ? [{ content: 'Dr Metal', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('cr_metal')
        ? [{ content: 'Cr Metal', styles: { halign: 'center' } }]
        : []),
      ...(checkList.includes('running_metal_balance')
        ? [{ content: 'Balance', styles: { halign: 'center' } }]
        : []),
    ],
  ];

  // const tableRows = filteredTableData.map((item) => [
  //   item['Date'],
  //   item['Vch. Type'],
  //   item['Particular'],
  //   item['Remarks'],
  //   item['Vch. No.'],
  //   item['Dr Amount'] || 0,
  //   item['Cr Amount'] || 0,
  //   item['Amount'] || 0,
  //   item['Dr Metal'] || 0,
  //   item['Cr Metal'] || 0,
  //   item['Metal'] || 0,
  // ]);
  const tableRows = filteredTableData.map((item, index) => [
    ...(checkList.includes('transaction_date')
      ? [item['transaction_date'] || '']
      : []),
    ...(checkList.includes('Vch. Type') ? [item['Vch. Type'] || ''] : []),
    ...(checkList.includes('particular') ? [item['particular'] || ''] : []),
    ...(checkList.includes('remarks') ? [item['remarks'] || ''] : []),
    ...(checkList.includes('vch_no') ? [item['vch_no'] || ''] : []),
    ...(checkList.includes('dr_amount') ? [item['dr_amount'] || 0] : []),
    ...(checkList.includes('cr_amount') ? [item['cr_amount'] || 0] : []),
    ...(checkList.includes('running_balance')
      ? [item['running_balance'] || 0]
      : []),
    ...(checkList.includes('dr_metal') ? [item['dr_metal'] || 0] : []),
    ...(checkList.includes('cr_metal') ? [item['cr_metal'] || 0] : []),
    ...(checkList.includes('running_metal_balance')
      ? [item['running_metal_balance'] || 0]
      : []),
  ]);

  // const summaryRow = [
  //   {
  //     content: '',
  //     colSpan: 5,
  //   },
  //   {
  //     content: `Opening:`,
  //     colSpan: 1,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: totalData?.totalAmountDr || '0.000',
  //     colSpan: 2,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: totalData?.totalMetalDr || '0.000',
  //     colSpan: 3,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   // {
  //   //   content: '',
  //   //   colSpan: 4,
  //   // },
  // ];

  // const summaryRow1 = [
  //   {
  //     content: '',
  //     colSpan: 5,
  //   },
  //   {
  //     content: 'Debit:',
  //     colSpan: 1,
  //     styles: { fontStyle: 'bold', halign: 'left' },
  //   },
  //   {
  //     content: totalData?.totalAmountDr || '0.000',
  //     colSpan: 2,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: totalData?.totalMetal || '0.000',
  //     colSpan: 3,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: '',
  //     colSpan: 2,
  //   },
  // ];

  // const summaryRow2 = [
  //   {
  //     content: '',
  //     colSpan: 5,
  //   },
  //   {
  //     content: 'Credit:',
  //     colSpan: 1,
  //     styles: { fontStyle: 'bold', halign: 'left' },
  //   },
  //   {
  //     content: totalData?.totalAmountCr || '0.000',
  //     colSpan: 2,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: '0.000',
  //     colSpan: 3,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: '',
  //     colSpan: 2,
  //   },
  // ];

  // const summaryRow3 = [
  //   {
  //     content: '',
  //     colSpan: 5,
  //   },
  //   {
  //     content: 'Closing:',
  //     colSpan: 1,
  //     styles: { halign: 'left', fontStyle: 'bold' },
  //   },
  //   {
  //     content: totalData?.totalAmount || '0.000',
  //     colSpan: 2,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: totalData?.totalMetal || '0.000',
  //     colSpan: 3,
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //   },
  //   {
  //     content: '',
  //     colSpan: 2,
  //   },
  // ];

  // Utility to get colSpan based on checkList
  // Utility to get colSpan for multiple columns
  const getColSpan = (cols) =>
    cols.reduce((span, col) => (checkList.includes(col) ? span + 1 : span), 0);

  // Opening summary row
  const summaryRow = [
    ...(checkList.includes('transaction_date') ||
    checkList.includes('Vch. Type') ||
    checkList.includes('particular') ||
    checkList.includes('remarks') ||
    checkList.includes('vch_no')
      ? [
          {
            content: '',
            colSpan: getColSpan([
              'transaction_date',
              'Vch. Type',
              'particular',
              'remarks',
              'vch_no',
            ]),
          },
        ]
      : []),
    {
      content: 'Opening:',
      styles: { halign: 'left', fontStyle: 'bold' },
      colSpan: getColSpan(['dr_amount', 'cr_amount', 'running_balance']),
    },
    ...(checkList.includes('dr_amount')
      ? [
          {
            content: totalData?.totalAmountDr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_amount')
      ? [
          {
            content: totalData?.totalAmountCr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('running_balance')
      ? [
          {
            content: totalData?.totalAmount || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('dr_metal')
      ? [
          {
            content: totalData?.totalMetalDr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_metal')
      ? [
          {
            content: totalData?.totalMetalCr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('running_metal_balance')
      ? [
          {
            content: totalData?.totalMetal || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
  ];

  // Debit summary row
  const summaryRow1 = [
    ...(checkList.includes('transaction_date') ||
    checkList.includes('Vch. Type') ||
    checkList.includes('particular') ||
    checkList.includes('remarks') ||
    checkList.includes('vch_no')
      ? [
          {
            content: '',
            colSpan: getColSpan([
              'transaction_date',
              'Vch. Type',
              'particular',
              'remarks',
              'vch_no',
            ]),
          },
        ]
      : []),
    {
      content: 'Debit:',
      styles: { halign: 'left', fontStyle: 'bold' },
      colSpan: getColSpan(['dr_amount', 'cr_amount', 'running_balance']),
    },
    ...(checkList.includes('dr_amount')
      ? [
          {
            content: totalData?.totalAmountDr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_amount')
      ? [
          {
            content: totalData?.totalAmount || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('dr_metal')
      ? [
          {
            content: totalData?.totalMetalDr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_metal')
      ? [
          {
            content: totalData?.totalMetal || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
  ];

  // Credit summary row
  const summaryRow2 = [
    ...(checkList.includes('transaction_date') ||
    checkList.includes('Vch. Type') ||
    checkList.includes('particular') ||
    checkList.includes('remarks') ||
    checkList.includes('vch_no')
      ? [
          {
            content: '',
            colSpan: getColSpan([
              'transaction_date',
              'Vch. Type',
              'particular',
              'remarks',
              'vch_no',
            ]),
          },
        ]
      : []),
    {
      content: 'Credit:',
      styles: { halign: 'left', fontStyle: 'bold' },
      colSpan: getColSpan(['dr_amount', 'cr_amount', 'running_balance']),
    },
    ...(checkList.includes('dr_amount')
      ? [
          {
            content: totalData?.totalAmount || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_amount')
      ? [
          {
            content: totalData?.totalAmountCr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('dr_metal')
      ? [
          {
            content: '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_metal')
      ? [
          {
            content: totalData?.totalMetal || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
  ];

  // Closing summary row
  const summaryRow3 = [
    ...(checkList.includes('trnsaction_date') ||
    checkList.includes('Vch. Type') ||
    checkList.includes('particular') ||
    checkList.includes('remarks') ||
    checkList.includes('vch_no')
      ? [
          {
            content: '',
            colSpan: getColSpan([
              'transaction_date',
              'Vch. Type',
              'particular',
              'remarks',
              'vch_no',
            ]),
          },
        ]
      : []),
    {
      content: 'Closing:',
      styles: { halign: 'left', fontStyle: 'bold' },
      colSpan: getColSpan(['dr_amount', 'cr_amount', 'running_balance']),
    },
    ...(checkList.includes('dr_amount')
      ? [
          {
            content: totalData?.totalAmount || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_amount')
      ? [
          {
            content: totalData?.totalAmountCr || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('dr_metal')
      ? [
          {
            content: totalData?.totalMetal || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
    ...(checkList.includes('cr_metal')
      ? [
          {
            content: totalData?.totalMetal || '0.000',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ]
      : []),
  ];

  doc.autoTable({
    head: tableHeaders,
    body: [...tableRows, ...summaryRows],
    margin: { left: 5, right: 5, top: yPosition },
    styles: {
      fontSize: 9,
      fontStyle: 'normal',
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: [200, 200, 200],
    },
    headStyles: {
      fillColor: [60, 179, 113], // Match the UI header color (greenish)
      textColor: 255, // White text
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
    didDrawPage: (data) => {
      // Draw header on every page
      yPosition = drawHeader();

      // Update the table's startY position for subsequent pages
      data.settings.margin.top = yPosition;

      // Draw footer
      doc.setFontSize(7);
      doc.setTextColor(100);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        15,
        pageHeight - 8,
      );
      doc.text(footerText, pageWidth / 2, pageHeight - 8, { align: 'center' });
    },
  });

  // Export
  if (task === 'print') {
    doc.autoPrint({ variant: 'non-conform' });
    doc.output('dataurlnewwindow');
  } else {
    doc.save(
      extension ? `${extension.replace(/\s+/g, '_')}.pdf` : 'report.pdf',
    );
  }
};
